import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';

// Types.
import InstanceTarget from '../../types/instance/InstanceTarget';
import HostTarget from '../../types/host/HostTarget';
import EventType from '../../types/instance/EventType';

// Constants.

// Views.
import List from './List';
import Instances from "./Instances";
import Detail from "./Detail";
import Events from "./Events";
import NotFound from "../NotFound";

interface IHostsProps {
    instances: InstanceTarget[],
    hosts: HostTarget[],
    eventTypes: EventType[],
    toggleMenu: Function,
    applyPeriod: Function,
    setFilterOptions: Function
}

interface IHostsState {
}

const initialState: IHostsState = {};

class Hosts extends Component<IHostsProps, IHostsState> {
    static propTypes: {
        toggleMenu: PropTypes.Validator<(...args: any[]) => any>,
        applyPeriod: PropTypes.Validator<(...args: any[]) => any>,
        setFilterOptions: PropTypes.Validator<(...args: any[]) => any>;
    };

    constructor(props: IHostsProps) {
        super(props);

        this.state = initialState;
    };

    render() {
        const {
            instances,
            hosts,
            eventTypes,
            toggleMenu,
            applyPeriod,
            setFilterOptions
        } = this.props;

        return (
            <React.Fragment>
                <Routes>
                    <Route path="/:hostId/instances"
                           element={<Instances toggleMenu={toggleMenu} applyPeriod={applyPeriod}
                                               hosts={hosts}
                                               setFilterOptions={setFilterOptions}/>} />

                    <Route path="/:hostId/events"
                           element={<Events instances={instances}
                                            eventTypes={eventTypes}
                                            hosts={hosts}
                                            toggleMenu={toggleMenu} applyPeriod={applyPeriod}
                                            setFilterOptions={setFilterOptions}/>} />

                    <Route path="/"
                           element={<List instances={instances} hosts={hosts}
                                          toggleMenu={toggleMenu} applyPeriod={applyPeriod}/>} />

                    <Route path="/:hostId"
                           element={<Detail instances={instances}
                                            hosts={hosts}
                                            toggleMenu={toggleMenu}
                                            applyPeriod={applyPeriod}/>} />

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </React.Fragment>
        );
    }
}

Hosts.propTypes = {
    toggleMenu: PropTypes.func.isRequired,
    applyPeriod: PropTypes.func.isRequired,
    setFilterOptions: PropTypes.func.isRequired
};

export default Hosts;
